/**
 * WordPress dependencies
 */
import { createContext, useContext, useState, useEffect } from '@wordpress/element';
import axios from 'axios';

const AppContext = createContext({
  categories: [],
  icons: [],
});

// Set axios defaults
axios.defaults.baseURL = "https://hugeicons.com/api";

export const AppContextProvider = ({children}) => {
  const [icons, setIcons] = useState([]);
  const [categories, setCategories] = useState([]);

  const getCategories = async () => {
    const response = await axios.get('/get-categories');
    setCategories(response?.data?.categories)
  }

  const getIcons = async () => {
    const response = await axios.get('/icons');
    setIcons(response?.data?.icons)
  }

  useEffect(() => {
    getCategories().finally()
    getIcons().finally()
  }, []);

  const contextValues = {
    categories,
    icons,
  };

  return (
    <AppContext.Provider value={contextValues}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext); 